import script from "./LabelTag.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelTag.vue?vue&type=script&setup=true&lang=js"

import "./LabelTag.vue?vue&type=style&index=0&id=75c78406&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c78406"]])

export default __exports__